import React from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Row,
  Dropdown,
  Tabs,
  Tab,
  Modal,
  Card,
} from "react-bootstrap";
import { Search, MoreVert, HelpOutline } from "@material-ui/icons";
import {
  getAllSubscriptionAction,
  removeProductAction,
  archiveSubscriptionAction,
} from "./../../actions/SubscriptionAction";
import { connect } from "react-redux";
import * as code from "./../../config/Constants";
import { toastMessage, currencyFormat } from "./../Common/Common";
import noRecord from "./../../assets/img/no-record.png";

class SubscriptionList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      monthData: [],
      originalMonthData: [],
      filterMonthData: [],
      yearData: [],
      originalYearData: [],
      filterYearData: [],
      searchParam: "",
      selectedKey: "monthly",
      deletePrompt: false,
      productID: "",
    };
  }
  componentWillMount() {
    this.setState({ showLoader: true });
    this.getSubscriptionList();
  }
  getSubscriptionList() {
    // this.props.getAllSubscriptionAction("month").then(monthRes => {
    //     this.setState({ showLoader: false });
    //     if (monthRes.status === code.OK) {
    //         this.setState({ monthData: monthRes.data, filterMonthData: monthRes.data, originalMonthData: monthRes.data });
    //     }
    // });
    // this.props.getAllSubscriptionAction("year").then(yearRes => {
    //     this.setState({ showLoader: false });
    //     if (yearRes.status === code.OK) {
    //         this.setState({ yearData: yearRes.data, filterYearData: yearRes.data, originalYearData: yearRes.data });
    //     }
    // })
  }
  handleSelect = (key) => {
    this.setState({ selectedKey: key });
    this.search(this.state.searchParam);
  };
  search(param) {
    param = param.trim();
    if (param != "") {
      var monthSubscription = [];
      monthSubscription = this.state.filterMonthData.filter((o) => {
        var found = false;
        Object.keys(o).forEach((v) => {
          if (v == "name" || v == "description") {
            let item = o[v] + "";
            item = item.replace(/\s+/g, " ");
            if (item.toLowerCase().includes(param.toLowerCase())) {
              found = true;
            }
          }
        });

        return found;
      });
      var subscription = [];
      subscription = this.state.filterYearData.filter((o) => {
        var found = false;
        Object.keys(o).forEach((v) => {
          if (v == "name" || v == "description") {
            let item = o[v] + "";
            item = item.replace(/\s+/g, " ");
            if (item.toLowerCase().includes(param.toLowerCase())) {
              found = true;
            }
          }
        });

        return found;
      });
      this.setState({
        yearData: subscription,
        monthData: monthSubscription,
        searchParam: param,
      });
    } else {
      this.setState({
        yearData: this.state.originalYearData,
        monthData: this.state.originalMonthData,
      });
    }
  }
  goToEditSubscription(data) {
    this.props.history.push({
      pathname: "/Subscription/EditSubscription",
      subscriptionData: data,
      editMode: true,
    });
  }
  removeProduct() {
    this.props.removeProductAction(this.state.productID).then((res) => {
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, res.data);
        this.deletePrompt();
        this.getSubscriptionList();
      } else {
        toastMessage(code.ERROR, res.data);
        this.deletePrompt();
      }
    });
  }
  archiveProduct(id) {
    this.setState({ showLoader: true });
    this.props.archiveSubscriptionAction(id).then((res) => {
      if (res.status === code.OK) {
        this.setState({ showLoader: false });
        this.getSubscriptionList();
      } else {
        this.setState({ showLoader: false });
      }
    });
  }
  /**
   * @desc open delete promt
   */
  deletePrompt() {
    this.setState({
      deletePrompt: !this.state.deletePrompt,
    });
  }
  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="subscription-panel">
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
              <Col>
                <h4 className="title-med mt-0 pt-1">Subscriptions</h4>
              </Col>
              <Col className="col-auto" align="right">
                <Form inline className="justify-content-end">
                  <Row className="trans-listing-head-row">
                    <Col className="col-auto px-0 d-flex trans-listing-head-dropdown">
                      <Form.Group controlId="" className="mb-0 mr-3">
                        <InputGroup className="icon-wrapper search-big">
                          <Form.Control
                            type="text"
                            className="form-control-head"
                            placeholder="Search"
                            value={this.state.searchParam}
                            onChange={(e) => {
                              this.search(e.target.value);
                              this.setState({ searchParam: e.target.value });
                            }}
                          />
                          <span className="form-control-icn">
                            <Search />
                          </span>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                      <Form.Group controlId="" className="mb-0">
                        <Button
                          variant="primary"
                          className="btn-blue btn-head hide-767"
                          onClick={() => {
                            this.props.history.push(
                              "/Subscription/AddSubscription"
                            );
                          }}
                        >
                          Add New Subscription
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <div className="container-custom pricing">
              <Tabs
                defaultActiveKey="monthly"
                id="uncontrolled-tab-example"
                className="subscription-tabs"
                onSelect={this.handleSelect}
              >
                <Tab eventKey="monthly" title="Monthly">
                  {this.state.monthData.length > 0 ? (
                    <Row>
                      {this.state.monthData.map((monthData) => {
                        let description =
                          "<div>" + monthData.description + "</div>";

                        return (
                          <Col lg={3} md={6} sm={6} className="plan-scheme">
                            <Card className="transaction-single">
                              <Card.Body>
                                <h4>
                                  {monthData.name}
                                  <Dropdown
                                    alignRight
                                    className="dropdown-action"
                                  >
                                    <Dropdown.Toggle
                                      variant="transparent"
                                      className="p-0"
                                    >
                                      <MoreVert />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() =>
                                          this.goToEditSubscription(monthData)
                                        }
                                      >
                                        Edit
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() =>
                                          this.archiveProduct(monthData._id)
                                        }
                                      >
                                        {monthData.isActive
                                          ? "Deactive"
                                          : "Active"}
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.deletePrompt();
                                          this.setState({
                                            productID: monthData._id,
                                          });
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </h4>
                                <p className="plan-price">
                                  {currencyFormat(monthData.price.unit_amount)}
                                  /mo.
                                </p>
                                <div className="plan-desc">
                                  <label>Description</label>
                                  <p
                                    className="plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: monthData.description,
                                    }}
                                  />
                                  <div
                                    className="more-plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  ) : (
                    <div className="no-transaction no-record no-datatable">
                      <div className="no-transaction-inner">
                        <img src={noRecord} alt="no record" />
                        <p>No Plans Found</p>
                      </div>
                    </div>
                  )}
                </Tab>
                <Tab eventKey="annually" title="Annually">
                  {this.state.yearData.length > 0 ? (
                    <Row>
                      {this.state.yearData.map((yearData) => {
                        let description =
                          "<div>" + yearData.description + "</div>";

                        return (
                          <Col lg={3} md={6} sm={6} className="plan-scheme">
                            <Card className="transaction-single">
                              <Card.Body>
                                <h4>
                                  {yearData.name}
                                  <Dropdown
                                    alignRight
                                    className="dropdown-action"
                                  >
                                    <Dropdown.Toggle
                                      variant="transparent"
                                      className="p-0"
                                    >
                                      <MoreVert />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() =>
                                          this.goToEditSubscription(yearData)
                                        }
                                      >
                                        Edit
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() =>
                                          this.archiveProduct(yearData._id)
                                        }
                                      >
                                        {yearData.isActive
                                          ? "Deactive"
                                          : "Active"}
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.deletePrompt();
                                          this.setState({
                                            productID: yearData._id,
                                          });
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </h4>
                                <p className="plan-price">
                                  {currencyFormat(yearData.price.unit_amount)}
                                  /yr.
                                </p>
                                <div className="plan-desc">
                                  <label>Description</label>
                                  <p
                                    className="plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: yearData.description,
                                    }}
                                  />
                                  <div
                                    className="more-plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  ) : (
                    <div className="no-transaction no-record no-datatable">
                      <div className="no-transaction-inner">
                        <img src={noRecord} alt="no record" />
                        <p>No Plans Found</p>
                      </div>
                    </div>
                  )}
                </Tab>
              </Tabs>
            </div>

            <Modal
              show={this.state.deletePrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400 modal-delete"
              centered
              backdrop={false}
            >
              <Modal.Body className="pb-0 text-center">
                <HelpOutline />
                <p>Are you sure you want to delete?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.deletePrompt();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    this.removeProduct();
                  }}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subscriptions: state.reducer.subscriptions,
  };
};
export default connect(
  mapStateToProps,
  {
    getAllSubscriptionAction,
    removeProductAction,
    archiveSubscriptionAction,
  }
)(SubscriptionList);
